import { b64url, utf8 } from "./b64";

async function publicJwk(keys: CryptoKeyPair): Promise<{ kty: string; crv: string; x: string; y: string }> {
  const { kty, crv, x, y } = await crypto.subtle.exportKey("jwk", keys.publicKey);
  return { kty: kty!, crv: crv!, x: x!, y: y! };
}

export async function thumbprint(keys: CryptoKeyPair): Promise<string> {
  const { crv, kty, x, y } = await publicJwk(keys); // RFC 7638: required members, lexicographic order
  const canonical = JSON.stringify({ crv, kty, x, y });
  return b64url(await crypto.subtle.digest("SHA-256", utf8(canonical)));
}

export async function proof(
  keys: CryptoKeyPair,
  method: string,
  url: string,
  options: { nonce?: string; accessToken?: string } = {},
): Promise<string> {
  const header = { typ: "dpop+jwt", alg: "ES256", jwk: await publicJwk(keys) };
  const claims: Record<string, unknown> = {
    htm: method,
    htu: url.split("?")[0]!.split("#")[0],
    iat: Math.floor(Date.now() / 1000),
    jti: crypto.randomUUID(),
  };
  if (options.nonce) claims.nonce = options.nonce;
  if (options.accessToken) claims.ath = b64url(await crypto.subtle.digest("SHA-256", utf8(options.accessToken)));
  const input = `${b64url(utf8(JSON.stringify(header)))}.${b64url(utf8(JSON.stringify(claims)))}`;
  const signature = await crypto.subtle.sign({ name: "ECDSA", hash: "SHA-256" }, keys.privateKey, utf8(input));
  return `${input}.${b64url(signature)}`; // WebCrypto ECDSA output is r||s, the JWS ES256 format
}
